module.exports = __webpack_public_path__ + "img/example.c4cfbe9.png";